// 小屏-档案馆
<template>
  <div class="DkbSNARA">
    <p class="sumTit">当前档案库存数量</p>
    <p class="sum">{{StockTotal}}</p>
    <p class="listTit">借/还档案记录</p>
    <div class="recordList DkbScroll">
      <div class="li" v-for="(item, index) in StockList" :key="index">
        <p class="No">{{index+1}}</p>
        <p class="name">{{item.Name}}</p>
        <p class="des">{{item.Des}}</p>
        <p class="time">{{item.Time}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  import { dkbApi } from "../../../../static/js/dkb/dkb.js"
  let vm, timer

  export default {
    name: 'DkbSNARA',
    components: {
    },
    props: {
      // 父组件传来的参数
      sData: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        StockTotal: this.sData.StockTotal,
        StockList: this.sData.StockList
      }
    },
    computed: {
    },
    created () {
      vm = this
      // console.log('tag', vm.sData)
      vm.timeRefresh()
    },
    mounted() {
      // console.log('route', this.$route)
    },
    destroyed () {
      clearInterval(timer)
    },
    methods: {
      // 定时刷新
      timeRefresh () {
        timer = setInterval(() => {
          vm.getNARAInfo()
        }, 1000*3)
      },
      // 获取档案室的信息（小屏）
      async getNARAInfo () {
        let res = await dkbApi.getNARAInfo()
        if (res.ErrCode === 0) {
          // console.log('res', res)
          let result  = res.Result
          vm.StockTotal = res.Result.StockTotal
          vm.StockList = [...res.Result.StockList]
        } else {
          showToast(res.ErrMsg)
        }
      }

    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbSNARA {
  height: 100%;
  text-align: center;
  padding: 0 0.68rem 0.24rem;
  display: flex;
  flex-direction: column;
  .sumTit {
    width: 100%;
    font-size: 0.15rem;
  }
  .sum {
    width: 100%;
    font-size: 0.5rem;
  }
  .listTit {
    width: 100%;
    margin-bottom: 0.01rem;
    font-weight: bold;
    font-size: 0.15rem;
    line-height: 0.4rem;
    background-color: #072c4e;
  }
  .recordList {
    width: 100%;
    max-height: 100%;
    // height: 100%;
    // background-color: #072c4e;
    overflow-x: hidden;
    overflow-y: scroll;
    .li {
      height: 0.24rem;
      line-height: 0.24rem;
      margin-right: 0.02rem;
      font-size: 0.12rem;
      background-color: #072c4e;
      display: flex;
      .No {
        flex-shrink: 0;
        width: 0.74rem;
        margin-left: 0.11rem;
      }
      .name {
        flex-shrink: 0;
        width: 0.95rem;
      }
      .des {
        flex-shrink: 0;
        width: 0.92rem;
      }
      .time {
        flex-shrink: 0;
        width: 1.62rem;
      }
    }
    .li:nth-child(odd) {
      background-color: #103b5c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/SScreen/NARA.vue